import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Center, Spinner } from 'src/components/atoms';
import { handleErrorToast } from 'src/components/molecules';
import { caseDataUpdated } from 'src/components/pages/Case/Case.slice';
import { CaseDetailsLayout } from 'src/components/pages/Case/CaseDetailsLayout';
import { useCase, useCaseDocuments, useQueryParams } from 'src/hooks';
import { CaseTypeEnum } from 'src/types';

export const DisclosureCaseDetail = () => {
  const dispatch = useDispatch();
  const queryParams = useQueryParams();
  const caseId = queryParams.get('id') ?? '';

  const {
    caseById,
    isLoading,
    isError,
    refetch,
    viewer,
    availableCategories,
    addCaseCategory,
    removeCaseCategory,
    isSaving,
    setIsSaving,
  } = useCase(caseId);

  const caseDocuments = useCaseDocuments(caseId, refetch, setIsSaving);

  useEffect(() => {
    if (caseById) {
      dispatch(caseDataUpdated(caseById));
    }
  }, [dispatch, caseById]);

  useEffect(() => {
    if (!caseId) {
      handleErrorToast({ toastMessage: 'Missing case id' });
      return;
    }
    if (isError) {
      handleErrorToast({ toastMessage: 'Invalid case id' });
    }
  }, [caseId, isError]);

  if (!caseId) {
    return <Redirect to="/disclosures" />;
  }

  if (isError) {
    return <Redirect to="/disclosures" />;
  }

  if (isLoading || !caseById || !viewer) {
    return (
      <Center data-testid="disclosure-case-detail-loading">
        <Spinner variant="secondary" size="xlarge" />
      </Center>
    );
  }

  if (
    caseById &&
    caseById.DisclosuresCaseData?.importType !== CaseTypeEnum.COI
  ) {
    return <Redirect to={`/case?id=${caseId}`} />;
  }

  const categories = caseById.Categories ?? [];

  return (
    <CaseDetailsLayout
      caseType={CaseTypeEnum.COI}
      caseId={caseId}
      caseById={caseById}
      viewer={viewer}
      refetch={refetch}
      addCaseCategory={addCaseCategory.mutate}
      removeCaseCategory={removeCaseCategory.mutate}
      availableCategories={availableCategories}
      categories={categories}
      caseDocuments={caseDocuments}
      isSaving={isSaving}
      setIsSaving={setIsSaving}
    />
  );
};
